export const EXPERIMENT_NAMES = {
  ACTUALIZE_ALTERNATIVES: {
    NAME: 'actualize_alternatives',
    OPTIONS: {
      ON: 'on',
      OFF: 'off',
    },
  },
} as const;
